// Temporary solution for checking if the page is loaded with engage domain
// It will be removed after the domain migration feature flight rollout to 100%
const engageDomain = 'engage.cloud.microsoft';
export const isLoadedWithEngageDomain = (): boolean => window.location.hostname === engageDomain;
